// src/pages/billing/CheckoutCancelPage.js
import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutCancelPage = () => {
    return (
        <div className="p-8 md:p-12 text-white text-center">
            <div className="max-w-md mx-auto">
                <div className="w-14 h-14 rounded-full bg-neutral-700 flex items-center justify-center mx-auto mb-6">
                    <svg className="w-7 h-7 text-neutral-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                <h1 className="text-3xl font-bold mb-3">Checkout Canceled</h1>
                <p className="text-neutral-400 mb-8">
                    No worries — your checkout was canceled and you have not been charged.
                    You can upgrade anytime.
                </p>
                <Link
                    to="/upgrade"
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-md transition-colors inline-block"
                >
                    Back to Pricing
                </Link>
            </div>
        </div>
    );
};

export default CheckoutCancelPage;
